import * as moment from 'moment'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { IWalletTransactionHistoryResponseDTO } from '../../../../types'
import { priceValueMask } from '../../../../utils/mask'

interface IWalletTransactionHistoryItemProps {
  transaction: IWalletTransactionHistoryResponseDTO
  timeFormat: string
}

class WalletTransactionHistoryListItem extends React.Component<IWalletTransactionHistoryItemProps, any> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    const { transaction } = this.props
    const transactionId = transaction.stripeTransactionId || 'N/A'
    const tripId =
      (transaction.rideId !== null && transaction.rideId.substring(0, Math.min(transaction.rideId.length, 6))) || 'N/A'

    return (
      <span className='flex items-center'>
        <div className='col-2'>
          <span className='h5 font-grey2'>{moment(transaction.createdAt).format('MM.DD.YY HH:mm A')}</span>
        </div>
        <div className='col-4'>
          <span className='TransactionId h5 font-grey2'>{transactionId}</span>
        </div>
        <div className='col-1'>
          {transaction.rideId ? (
            <Link to={`/trips/${transaction.rideId}`}>
              <span className='TransactionId h5 font-blue underline'>{tripId}</span>
            </Link>
          ) : (
            <span className='TransactionId h5 font-grey2'>{tripId}</span>
          )}
        </div>
        <div className='col-1'>
          <span className='TransactionType h5 font-grey2'>{transaction.transactionType}</span>
        </div>
        <div className='col-2'>
          <span className='h5 font-grey2'>{transaction.paymentMethod}</span>
        </div>
        <div className='col-1-5'>
          <span className='h5 font-grey2'>
            <span className={transaction.transactionType === 'CR' ? 'font-green' : 'font-red'}>
              {(transaction.transactionType === 'CR' ? '+' : '-') + priceValueMask(transaction.amount / 100)}
            </span>
          </span>
        </div>
        <div className='col-1-5'>
          <span className='h5 font-grey2'>{priceValueMask(transaction.totalBalance / 100)}</span>
        </div>
        <div className='col-3'>
          <span className='h5 font-grey2'>{transaction.transactionMessage}</span>
        </div>
        <div className='col-2'>
          <span className='h5 font-grey2'>
            {transaction.initiatorUser
              ? `${transaction.initiatorUser.firstName} ${transaction.initiatorUser.lastName}`
              : ''}
          </span>
        </div>
      </span>
    )
  }
}

export default WalletTransactionHistoryListItem



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/WalletTransactionHistoryListItem.tsx